exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn{position:absolute;top:100px;right:140px;width:250px;height:100px;font-size:100px;border-radius:10px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./components/App.css
 ** module id = 91
 ** module chunks = 0
 **/